import useGoogleTagManagerScriptInit from "./hooks/useGoogleTagManagerScriptInit";
import { getDomainConfig } from "../../app/appSelectors";
import { useSelector } from "react-redux";

function GoogleTagManagerProvider() {
    const domainConfig = useSelector(getDomainConfig);

    useGoogleTagManagerScriptInit(domainConfig?.gtmId)

    return null;
}

export default GoogleTagManagerProvider;
